var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-views has-side-bars"},[(_vm.noteText)?_c('ItemNote',{attrs:{"text":_vm.noteText}}):_vm._e(),_c('ItemNote',{attrs:{"text":_vm.views + _vm.$t('views_last_year')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }